import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";

@Component({
  selector: 'app-sincronizar-99food-status',
  templateUrl: './sincronizar-food99.component.html',
  styleUrls: ['./sincronizar-food99.component.scss']
})
export class SincronizarFood99Component implements OnInit {
  @Input() pedido: any = {}

  constructor(private pedidosService: PedidosService) {

  }

  ngOnInit(): void {
  }

  async sincronizarStatusPedido($event: any) {

    this.pedido.sincronizando = true;

    this.pedidosService.sincronizePedido99Food( this.pedido).then((resposta: any) => {
      this.pedido.sincronizando = false;
      if(resposta && resposta.id)
        Object.assign( this.pedido, resposta);
    }).catch((err) => {
      this.pedido.sincronizando = false;
    });

    $event.stopPropagation();
    $event.preventDefault();

    return false;
  }

}
